import React from "react";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <span>© 2026 ZAM ZAM RESTAURANTS</span>
        <span className="site-footer__sep">|</span>
        <a
          href="https://www.zamzamrestaurants.com/terms-and-conditions.html"
          target="_blank"
          rel="noopener noreferrer"
          className="site-footer__link"
        >
          TERMS &amp; CONDITIONS
        </a>
        <span className="site-footer__sep">|</span>
        <a
          href="https://www.zamzamrestaurants.com/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="site-footer__link"
        >
          PRIVACY POLICY
        </a>
        <span className="site-footer__sep">|</span>
        <a
          href="https://www.zamzamrestaurants.com/cancellation-and-refund-policy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="site-footer__link"
        >
          CANCELLATION AND REFUND POLICY
        </a>
      </div>
    </footer>
  );
};

export default Footer;
